import axios from 'axios'

export const login = (email, password) => async (dispatch) => {

    try {

        dispatch({
            type: 'USER_LOGIN_PENDING'
        })

        const loginData = new URLSearchParams();
        loginData.append('email', email);
        loginData.append('password', password);

        const { data } = await axios.post(process.env.REACT_APP_API_ENDPOINT + '/login',
            loginData,
        )

        if (data.status === "ok") {
            dispatch({
                type: 'USER_LOGIN_SUCCESS',
                payload: data
            })

            localStorage.setItem('userDetails', JSON.stringify(data))
            window.location.href = '/app/dashboard';

        } else {
            dispatch({
                type: 'USER_LOGIN_FAILED',
                payload: data.status && data.error.message
                    ? data.error.message
                    : data.status,
            })
        }


    } catch (error) {
        dispatch({
            type: 'USER_LOGIN_FAILED',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

export const loggedProfile = () => async (dispatch, getState) => {

    let xLang
    if (navigator.languages === undefined) {
        xLang = 'en'
    } else {
        if (navigator.languages[0] === "it-IT") {
            xLang = 'it'
        } else {
            xLang = 'en'
        }
    }

    try {
        dispatch({
            type: 'PROFILE_REQUEST',
        })

        const { userLogin: { userDetails } } = getState()

        const configuration = {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': userDetails.token,
                'x-language': xLang,
            },
        }

        const { data } = await axios.get(
            process.env.REACT_APP_API_ENDPOINT + '/users/whoami',
            configuration
        )

        dispatch({
            type: 'PROFILE_SUCCESS',
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: 'PROFILE_LOGOUT',
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }

}

export const logout = () => async (dispatch) => {
    localStorage.removeItem('userDetails')
    dispatch({ type: 'USER_LOGOUT' })
    document.location.href = '/app/login'
}